import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTheme } from 'next-themes';
import VerificationForm from '../../components/Auth/VerificationForm';

const VerifyEmailPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  const currentTheme = theme === 'system' ? systemTheme : theme;
  const isDarkMode = currentTheme === 'dark';

  useEffect(() => {
    setMounted(true);
  }, []);

  // Se não houver email, redirecionar para registro
  useEffect(() => {
    if (!email) {
      navigate('/register');
    }
  }, [email, navigate]);

  if (!email) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <Link
          to="/register"
          className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-secondary transition-colors hover:text-secondary/80"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          Voltar para registro
        </Link>

        <div className="bg-card rounded-lg shadow-xl p-8 border border-border">
          {/* Header */}
          <div className="text-center mb-8">
            {mounted && (
              <img
                src={isDarkMode
                  ? "/imgs/logos/EscriturIA-logo-horizontal.png"
                  : "/imgs/logos/EscriturIA-logo-horizontal-sem-slogan.png"
                }
                alt="EscriturIA Logo"
                className="h-16 mx-auto mb-4"
              />
            )}
            <h1 className="text-2xl font-bold text-secondary font-serif">
              Verificar Email
            </h1>
            <p className="text-brand-text-muted mt-2">
              Digite o código enviado para seu email
            </p>
          </div>

          {/* Verification Form */}
          <VerificationForm 
            email={email}
            onSuccess={() => {
              // Sucesso será tratado no componente
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;

